import { AreaChart, AreaChartProps, LineChart, LineChartProps } from '@mantine/charts'
import { Center, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'
import { memo } from 'react'
import { YAxis } from 'recharts'

import { type UseCoinLineChartProps, useCoinLineChartProps } from '../hooks/useCoinLineChartProps'
import { CHART_HEIGHT } from '../utils'

export default memo(function BasicLineChart({
  btcPricesVisible,
  btcCoinPrices,
  currentCoinPrices,
  onShowPriceTooltip,
}: UseCoinLineChartProps) {
  const LineComponent = btcPricesVisible ? LineChart : AreaChart
  const coinLineChartProps = useCoinLineChartProps({
    btcPricesVisible,
    currentCoinPrices,
    btcCoinPrices,
    onShowPriceTooltip,
  }) as AreaChartProps & LineChartProps
  const t = useTranslations('chart')

  if (!currentCoinPrices?.prices?.length)
    return (
      <Center h={CHART_HEIGHT}>
        <Text variant={'body'} c={'var(--text-secondary)'}>
          {t('noData')}
        </Text>
      </Center>
    )
  return (
    //  withXAxis and withYAxis to false make YAxis do not render in LineComponent
    <LineComponent {...coinLineChartProps} withXAxis={false} withYAxis={false}>
      {/*
        The order of svg layer is control by the order of svg's element
        yAxis is hard code in LineComponent,that we can not control the layer by coinLineChartProps
        The children in LineComponent is in the latest
        So we can use children to render YAxis make it have higher priority
      */}
      <YAxis yAxisId="right" orientation="right" {...coinLineChartProps.rightYAxisProps} />
      {coinLineChartProps.withYAxis && (
        <YAxis yAxisId="left" orientation="left" {...coinLineChartProps.yAxisProps} />
      )}
    </LineComponent>
  )
})
